import dayjs from "dayjs";
import React from "react";

const TransactionItem = ({ data }) => {
  const statusHexColorMap = {
    completed: "#06D6A0",
    failed: "#ef427c",
  };

  return (
    <>
      <div
        className="relative block z-0 overflow-hidden bg-white py-4 px-4 rounded-lg border border-md-pink-light-1 hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 hover:bg-md-pink-light-2"
        style={{ "--statusColor": statusHexColorMap[data?.status] }}
      >
        <div
          className="absolute top-1/2 left-0 h-full aspect-square z-[-1] -translate-y-1/2 -translate-x-1/2 rounded-full blur-xl opacity-10"
          style={{ backgroundColor: "var(--statusColor)" }}
        />
        <div className="flex">
          <div className="flex-shrink flex-grow space-y-2">
            <h2 className="text-base 2xl:text-lg font-semibold text-md-dark !leading-none">
              {data?.paymentGateway?.transactionId}
            </h2>
            <div className="relative">
              <div className="text-xs 2xl:text-sm text-slate-400">
                {dayjs(data?.createdAt).format("DD MMM, YYYY")}
              </div>
              <div className="text-sm 2xl:text-base text-slate-500">
                {data?.description || "Transaction Details"}
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 flex flex-col justify-between items-end">
            <div
              className="relative text-[10px] inline-flex items-center gap-x-1 leading-none uppercase py-1 px-1 rounded-full tracking-widest font-semibold"
              style={{ color: "var(--statusColor)" }}
            >
              <div
                className="absolute top-0 left-0 w-full h-full rounded-xl opacity-10"
                style={{ backgroundColor: "var(--statusColor)" }}
              />
              <div
                className="absolute top-0 left-0 w-full h-full rounded-xl border opacity-10"
                style={{ borderColor: "var(--statusColor)" }}
              />
              <div
                className="w-3 h-3 rounded-full animate-pulse"
                style={{ backgroundColor: "var(--statusColor)" }}
              />
              <span className="px-1">{data?.status}</span>
            </div>
            <div className="text-lg 2xl:text-xl font-semibold text-md-dark">
              {"$" + data?.amount}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionItem;
